import { render, staticRenderFns } from "./Prize_shop_item_modal.vue?vue&type=template&id=d859266c&scoped=true"
import script from "./Prize_shop_item_modal.vue?vue&type=script&lang=js"
export * from "./Prize_shop_item_modal.vue?vue&type=script&lang=js"
import style0 from "./Prize_shop_item_modal.vue?vue&type=style&index=0&id=d859266c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d859266c",
  null
  
)

export default component.exports